import { Button } from '@mui/material';
import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import API from '../../api';
import { FileMultipleUploader, FormInput, FormTextArea, PageHeader } from '../../components';
import { SnackbarContext } from '../../contexts';
import { useLabel } from '../../hooks';

export const MethodologyRequestPage = (props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { ERROR, ROUTE_PATH, METHODOLOGY_CONSULTATION: METHODOLOGY } = useLabel();
  const { updateSnackbar } = useContext(SnackbarContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      title: '',
      content: '',
      files: [],
    },
  });

  const validations = {
    title: {
      required: ERROR.TITLE_BLANK,
      validate: (value) => !!value.trim() || ERROR.TITLE_BLANK,
    },
    content: {
      required: ERROR.CONTENT_BLANK,
      validate: (value) => !!value.trim() || ERROR.CONTENT_BLANK,
    },
  };

  const onSubmit = (data) => {
    API.User.PostInquiry({ ...data, type: 'Methodology' }).then(
      (res) => {
        history.push('/request_complete?type=mypage');
      },
      (err) => {
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.message,
        });
      },
    );
  };

  return (
    <article className='basic-page'>
      <PageHeader type='methodology' title={ROUTE_PATH['CONSULTATION_REQUEST']} />
      <article className='content__wrapper'>
        <section className='guide-text__container'>
          <h1>{METHODOLOGY['ARE_YOU_PREPARING']}</h1>
          <h1 style={{ marginBottom: 10 }}>{METHODOLOGY['YOU_CAN_GET_HELP']}</h1>
          <span>{METHODOLOGY['WE_WILL_CONTACT_YOU']}</span>
        </section>
        <form className='mt-8 w-full' id='request-form' noValidate onSubmit={handleSubmit(onSubmit)}>
          <section className='form__container'>
            <ul className='grid'>
              <div style={{ gridColumn: '1/3' }}>
                <FormInput
                  label={t('TITLE')}
                  required
                  placeholder={t('TITLE')}
                  error={errors.title}
                  {...register('title', {
                    required: validations.title.required,
                    validate: validations.title.validate,
                  })}
                />
              </div>
              <div style={{ gridColumn: '1/3', marginTop: 16, marginBottom: 16 }}>
                <FormTextArea
                  label={t('CONTENT')}
                  required
                  rows={12}
                  placeholder={t('CONTENT')}
                  maxLength={500}
                  error={errors.content}
                  {...register('content', {
                    required: validations.content.required,
                    validate: validations.content.validate,
                  })}
                />
              </div>
              <FileMultipleUploader
                value={watch('files')}
                onChange={(value) => setValue('files', value)}
                meta={{
                  key: 'files',
                  type: 'file',
                  label: t('FILE'),
                  subLabel: t('MAXIMUM_ATTACHMENTS'),
                  path: 'dummy',
                  max: 10,
                  style: { gridColumn: '1/3' },
                  validateFileSize: true,
                }}
              ></FileMultipleUploader>
            </ul>
          </section>
        </form>
        <div className='border-grey-200 my-8'></div>
        <section className=''>
          <Button
            className='w-[240px] h-[56px] !rounded-lg'
            variant='contained'
            color='primary'
            type='submit'
            form='request-form'
          >
            {t('SUBMIT')}
          </Button>
        </section>
      </article>
    </article>
  );
};
